<div class="flex flex-col min-h-screen w-full">
  <app-hero-section (scrollToMainContent)="scrollToDiscoverTitle()"></app-hero-section>
  <main class="flex-1 w-full">
    <app-discover-section></app-discover-section>
    <app-flexible-section></app-flexible-section>
    <app-howto-section></app-howto-section>
    <app-organizations-section></app-organizations-section>
    <app-testimonial-section></app-testimonial-section>
    <app-services-section id="services"></app-services-section>
    <app-moreinfo-section></app-moreinfo-section>
  </main>
  <app-footer></app-footer>
</div>
